export default __webpack_public_path__ + "static/media/pieczatka10.3ae98889.gif";